import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import store from '@/store'

const service = axios.create({})

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const isAuthRequest = config.url && new RegExp('/oauth/(token|activate-patient)$').test(config.url)
    const token = store.getters['user/access_token']
    const baseURL = store.getters['app/baseURL']
    if (token && !config.headers.Authorization && !isAuthRequest) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.baseURL = baseURL
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Response interceptor
service.interceptors.response.use(
  response => response,
  error => {
    if (
      error?.response?.status === 401 &&
      !new RegExp('/oauth/token$').test(error.config.url)
    ) {
      return store.dispatch('user/QueueFailedRequest', error.config)
    }
    return Promise.reject(error)
  }
)

export default service
export const deAxios = (response: AxiosResponse) => response.data
